<template>
  <Loader v-if="isLoading"></Loader>
  <div v-else>
    <b-row>
      <b-col>
        <b-row v-if="item" class="mb-2">
          <b-col>
            <router-link v-if="ableToEditUserData" :to="{ name: 'UserDataUpdate', params: { id: item['@id'] } }" class="btn btn-default btn-sm">
              <span v-if="!mobileView">{{ $t('buttons.edit') }}</span>
              <i v-else class="far fa-edit"></i>
            </router-link>
            <button v-if="ableToEditUserData" class="btn btn-warning btn-sm" @click="archiveItem(item)">{{ $t('buttons.archive') }}</button>
            <router-link
              v-if="prevRoute.name === 'TimetableDashboard'"
              :to="{ name: 'TimetableDashboard' }" class="btn btn-default float-right">
              <span v-if="!mobileView">{{$t('buttons.backToCRM')}}</span>
              <i v-else class="far fa-arrow-alt-left"></i>
            </router-link>
            <router-link v-else :to="{ name: 'FirmList', query: {p: currentPage} }" class="btn btn-sm btn-default float-right">
              <span v-if="!mobileView">{{$t('buttons.backToList')}}</span>
              <i v-else class="far fa-arrow-alt-left"></i>
            </router-link>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-card>
          <p><b>{{$t('views.userdata.form.name')}}:</b> {{ item.name }}</p>
          <p><b>{{$t('views.userdata.form.surname')}}:</b> {{ item.surname }}</p>
          <p v-if="item.phone"><b>{{$t('views.userdata.form.mobilePhone')}}:</b> <phoneNumberLink :phoneNumber="item.phone"/></p>
          <p v-if="item.city"><b>{{$t('views.firm.show.city')}}:</b> {{ item.city }}</p>
          <p v-if="item.street"><b>{{$t('views.firm.show.street')}}:</b> {{ item.street }}</p>
          <p v-if="item.postcode"><b>{{$t('views.firm.show.postcode')}}:</b> {{ item.postcode }}</p>
          <p v-if="item.province"><b>{{$t('views.firm.show.province')}}:</b> {{ item.province }}</p>
          <p v-if="item.userEmail"><b>{{$t('views.agreements.show.email')}}:</b> <a :href="'mailto: ' + item.userEmail"> {{item.userEmail}}</a></p>
          <p v-if="item.contactEmail"><b>{{$t('views.userdata.form.contactEmail')}}:</b> <a :href="'mailto: ' + item.contactEmail"> {{item.contactEmail}}</a></p>
          <p v-if="item.mobilePhone"><b>{{$t('views.agreements.show.mobilePhone')}}:</b> <phoneNumberLink :phoneNumber="item.mobilePhone"/></p>
        </b-card>
        <b-card>
          <b-tabs v-model="tabIndex" content-class="mt-3">
            <b-tab :title="$t('views.excmcase.list.titleOpened')">
              <CasesList :search-params="{relatedUserData: getIdLink(idContractor), status: 1, disableRolesFiltering: 1}" v-if="tabIndex === 0"></CasesList>
            </b-tab>
            <b-tab :title="$t('views.excmcase.list.titleClosed')">
              <CasesList :search-params="{relatedUserData: getIdLink(idContractor), status: 2, disableRolesFiltering: 1}" v-if="tabIndex === 1"></CasesList>
            </b-tab>
          </b-tabs>
        </b-card>
      </b-col>
      <b-col cols="4">
        <b-card>
          <b-col class="mt-2">
            <upcoming-relations
              :id-firm="parseInt(getIdLink(idContractor))"
              :contact-type="1"
            ></upcoming-relations>
          </b-col>
        </b-card>
        <b-card>
          <b-col class="mt-2">
            <upcoming-relations
              :id-firm="parseInt(getIdLink(idContractor))"
              :contact-type="2"
            ></upcoming-relations>
          </b-col>
        </b-card>
        <b-card>
          <b-col class="mt-2">
            <timetable-notes :id-firm="idContractor"></timetable-notes>
          </b-col>
        </b-card>
      </b-col>
    </b-row>
    <MeetingCreateModal :contact-type="1" :id-firm="idContractor"></MeetingCreateModal>
    <PhoneCreateModal :id-firm="idContractor"></PhoneCreateModal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ApiService from '@/utils/ApiService'
import addParamsToQuery from '@/utils/addParamsToQuery'
import getId from '@/utils/getIdFromLink'
import Loader from '@/components/Dashboard/Layout/Loader'
import { checkPermission } from '@/utils/checkRoles'
import UpcomingRelations from '@/components/Dashboard/Views/common/UpcomingRelations'
import TimetableNotes from '@/components/Dashboard/Views/common/TimetableNotes'
import CasesList from '@/components/Dashboard/Views/excmcase/Table'
import MeetingCreateModal from '@/components/Dashboard/Views/excmrelation/modals/MeetingCreateModal'
import PhoneCreateModal from '@/components/Dashboard/Views/excmrelation/modals/PhoneCreateModal'
import PhoneNumberLink from '@/components/Dashboard/Views/firm/components/PhoneNumberLink'

export default {
  name: 'Show',

  components: {
    PhoneNumberLink,
    Loader,
    UpcomingRelations,
    TimetableNotes,
    CasesList,
    MeetingCreateModal,
    PhoneCreateModal
  },

  data () {
    return {
      prevRoute: null,
      tabIndex: 0
    }
  },

  computed: {
    ...mapGetters({
      isLoading: 'userdata/show/isLoading',
      item: 'userdata/show/retrieved',
      currentPage: 'userdata/list/currentPage'
    }),
    idContractor () {
      return this.$route.params.id
    },
    mobileView () {
      return this.$store.state.mobileView
    },
    ableToEditUserData () {
      return checkPermission('userdatas', 'UserDataUpdate')
    }
  },

  watch: {
  },

  created () {
    this.retrieve(this.idContractor)
    this.getNotes()
  },

  beforeRouteEnter (to, from, next) {
    next((vm) => {
      vm.prevRoute = from
    })
  },

  methods: {
    changeCasesTab (val) {
      if (val === 1) {
        this.openCasesTab = true
        this.closedCasesTab = false
      } else {
        this.openCasesTab = false
        this.closedCasesTab = true
      }
    },
    ...mapActions({
      reset: 'userdata/show/reset',
      retrieve: 'userdata/show/retrieve',
      getNotesList: 'excmnote/list/default'
    }),
    getNotes () {
      let searchParams = {
        idUserData: getId(this.idContractor),
        state: 1
      }
      let url = addParamsToQuery('e_x_c_m_notes', searchParams)
      this.getNotesList(url)
    },
    archiveItem () {
      this.$Swal({
        title: this.$t('notifications.archiveTitle') + ' ' + this.$t('notifications.archiveDescription'),
        type: 'question',
        showConfirmButton: true,
        confirmButtonText: this.$t('buttons.yes'),
        showCancelButton: true,
        cancelButtonText: this.$t('buttons.cancel')
      }).then((result) => {
        if (result) {
          const response = new ApiService(this.item['@id']).put({ state: 0 })
          response.then(res => {
            this.$router.push({ name: 'FirmList' })
            this.$Swal({ // show notification with success
              type: 'success',
              title: this.$t('notifications.update.updatedTitle'),
              showConfirmButton: false,
              timer: 2500
            })
          })
        }
      })
    },
    getIdLink (link) {
      return getId(link)
    }
  }
}
</script>

<style scoped>

</style>
